import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthModule } from "./auth/auth.module";
import { MainModule } from "./main/main.module";
import { NetworkService } from "./shared/network.service";
import { CommonService } from "./shared/common.service";
import { AuthGuardMain } from "./auth/auth-guard.service";
import { AppRoutingModule } from "./app.routing";
import { Routes, RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng2TelInputModule } from "ng2-tel-input";
import { SharedModule } from "../app/shared/shared.module";
import { AuthProfileComponent } from "./auth-profile/auth-profile.component";
import { MatFormFieldModule, MatHorizontalStepper, MatInputModule, MatStepperModule } from "@angular/material";
import { PlansComponent } from "./plans/plans.component";
import { ScholarshipsComponent } from "./scholarships/scholarships.component";
import { AboutusComponent } from "./aboutus/aboutus.component";
// import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
// import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
// import { AngularFireAuthModule } from "@angular/fire/compat/auth";
// import { AngularFireModule } from "@angular/fire/compat";
// import { MessagingService } from "./serivce/messaging.service";
// import { environment } from "../environments/environment";
// import { AsyncPipe } from "../../node_modules/@angular/common";
// import { initializeApp, provideFirebaseApp } from "@angular/fire/app";

const routes: Routes = [{ path: "", redirectTo: "auth/login", pathMatch: "full" }];

@NgModule({
  declarations: [AppComponent, AuthProfileComponent, PlansComponent, ScholarshipsComponent, AboutusComponent],
  imports: [
    AuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpClientModule,
    MainModule,
    NgbModule,
    AppRoutingModule,
    Ng2TelInputModule,
    SharedModule,
    MatStepperModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" }),
    // AngularFireDatabaseModule,
    // AngularFireAuthModule,
    // AngularFireMessagingModule,
    // AngularFireModule.initializeApp(environment.firebase),
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
  ],
  exports: [AuthProfileComponent, BrowserModule],
  providers: [NetworkService, CommonService, AuthGuardMain, MatHorizontalStepper],

  bootstrap: [AppComponent],
})
export class AppModule {}
